import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import { useDispatch } from "react-redux";
import useTranslations from "../components/Translations/useTranslations";
import { welcomeLogo as logo } from "../components/logo";
import theme from "../components/ui/theme";
import Button from "../components/ui/Buttons";
import { auth } from "../components/Auth/api";
import { auth as authPath } from "../routes/auth";
import { showSnackbar } from "../components/Snackbar/actions";
import history from "../history";

function ForgotPasswordPage() {
  const trl = useTranslations();
  const dispatch = useDispatch();

  const [is_requesting, setIsRequesting] = useState(false);
  const [credentials, setCredentials] = useState({});

  const forgotPasswordForm = () => {
    const styles = {
      inputContainer: {
        ...theme.neumorphicOutset,
        borderRadius: 100,
        padding: theme.spacing(0.75),
      },
      input: {
        width: "100%",
        border: "none",
        backgroundColor: "transparent",
        outline: "none",
      },
    };
    const _onChange = (e) => {
      setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };

    const requestNewPassword = (credentials) => {
      setIsRequesting(true);

      auth.forgotPassword(credentials.code).then((data) => {
        setIsRequesting(false);
        if (data.success === false) {
          dispatch(
            showSnackbar({
              label: data.status_msg,
              type: "error",
              open: true,
              delay: 10000,
            })
          );
          return;
        }
        dispatch(
          showSnackbar({
            label:
              data.message || "Si ce compte existe, un e-mail de réinitialisation vous a été envoyé.",
            type: "success",
            open: true,
            delay: 10000,
          })
        );
        history.replace(authPath.LOGIN.path);
      });
    };
    const _onSubmit = (e) => {
      if (e) e.preventDefault();
      requestNewPassword(credentials);
    };

    return (
      <form onSubmit={_onSubmit}>
        <div className="my-5">
          <div className="mt-3" style={styles.inputContainer}>
            <input
              style={styles.input}
              onChange={(e) => _onChange(e)}
              name="code"
              type="text"
              required
              placeholder={trl.message("LoginPage.loginInputPlaceholder")}
            />
          </div>
        </div>
        <Button
          type="submit"
          block
          loading={is_requesting}
          label="Demander un nouveau mot de passe"
        />
        <Box>
          <Link to={authPath.LOGIN.path}>Se connecter</Link>
        </Box>
      </form>
    );
  };

  return (
    <React.Fragment>
      <Container>
        <Row
          style={{ height: "calc(100vh - 1.5rem)" }}
          className="justify-content-center align-items-center"
        >
          <Col md={6} lg={4}>
            <Box display="flex" justifyContent="center">
              <img className="img-fluid" src={logo} alt="Logo" />
            </Box>
            <Box mt={2}>
              <Typography variant="h6" align="center">
                {trl.message("LoginPage.title")}
              </Typography>
            </Box>
            {forgotPasswordForm()}
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
}

export default ForgotPasswordPage;
